import { Box, Text } from '@bonusly/design-system';

import { Bizy } from '../../../bizy';

type RecipientBizyGuideProps = {
	title: string;
	message: string;
};

export const RecipientBizyGuide = ({ title, message }: RecipientBizyGuideProps) => {
	return (
		<Box p={2} w="full" data-testid="recipient-bizy-guide">
			<Box bg="bg.surface" border="1px solid" borderColor="border.soft" borderRadius="12px" boxShadow="0 3px 3px 0 rgba(0,0,0,0.08)" px={2} py={2}>
				<Box display="flex" alignItems="center" columnGap={2}>
					<Bizy state="curious" size={28} freeze />
					<Box>
						<Text color="text.default" fontSize="sm" fontWeight="medium" lineHeight={4}>
							Bizy
						</Text>
						<Text color="text.softer" fontSize="xs" lineHeight={4}>
							@bizy
						</Text>
					</Box>
				</Box>
				<Box borderTop="1px solid" borderTopColor="border.soft" my={2} />
				<Box px={1}>
					<Text color="text.default" fontSize="sm" fontWeight="medium" textAlign="left" lineHeight={5}>
						{title}
					</Text>
					<Text color="text.softer" fontSize="sm" fontWeight="normal" textAlign="left" lineHeight={5}>
						{message}
					</Text>
				</Box>
			</Box>
		</Box>
	);
};
